import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { EmployeeLogTypes } from "../../../enums/employee-log-type.enum";
import { AddOrEditEmployeeLogModel } from "../../../models/employees/add-or-edit-employee-log.model";
import * as moment from "moment";
import { Subject, takeUntil } from "rxjs";
import { ManagerEmployeeService } from "../../../services/employees/manager-employees.service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-assign-shift',
  templateUrl: './assign-shift.component.html',
  styleUrls: ['./assign-shift.component.scss']
})
export class AssignShiftComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  public logType: EmployeeLogTypes | null = null;
  public addOrEditEmployeeLogModel: AddOrEditEmployeeLogModel;
  public EmployeeLogTypes = EmployeeLogTypes;
  public userId: string;
  public employeeFirstName: string;
  public employeeLastName: string;
  public date: Date;
  public editEnabled: boolean = false;
  public errorModel: { [k: string]: any } = {};
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public invalidInputMessage = "INFO.INVALID_VALUE";
  public disableBtn: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private employeeService: ManagerEmployeeService,
              private messageService: MessageService,
              public translate: TranslateService) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe( () => {
      this.ngOnInit();
    });

    if (this.config.data != undefined && this.config.data.logData) {
      this.editEnabled = true;

      this.addOrEditEmployeeLogModel = new AddOrEditEmployeeLogModel();
      this.addOrEditEmployeeLogModel.id = this.config.data.logData.id;
      this.addOrEditEmployeeLogModel.to = this.config.data.logData.to?.trim();
      this.addOrEditEmployeeLogModel.from = this.config.data.logData.from?.trim();
      this.addOrEditEmployeeLogModel.employeeLogTypeId = this.config.data.logData.employeeLogTypeId;
      this.addOrEditEmployeeLogModel.venueId = this.config.data.logData.venueId;
      this.chooseShiftDayType(this.addOrEditEmployeeLogModel.employeeLogTypeId);
    } else {
      this.addOrEditEmployeeLogModel = new AddOrEditEmployeeLogModel();
    }

    if (this.config.data != undefined && this.config.data.id && this.config.data.date) {
      this.userId = this.config.data.id;
      this.date = this.config.data.date;
      this.employeeLastName = this.config.data.employeeLastName;
      this.employeeFirstName = this.config.data.employeeFirstName;
      this.addOrEditEmployeeLogModel.venueId = this.config.data.venueId;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  addEmployeeLog() {
    this.errorModel = {};
    let addModel = new AddOrEditEmployeeLogModel();

    if (this.logType !== null) {

      if (this.logType === EmployeeLogTypes.Shift) {

        if (this.addOrEditEmployeeLogModel.to === undefined || this.addOrEditEmployeeLogModel.to === null) {
          this.errorModel['To'] = this.requiredFieldErrorMessage;
        } else if (+this.addOrEditEmployeeLogModel.to < 0 || +this.addOrEditEmployeeLogModel.to > 24) {
          this.errorModel['To'] = this.invalidInputMessage;
        }

        if (this.addOrEditEmployeeLogModel.from === undefined || this.addOrEditEmployeeLogModel.from === null) {
          this.errorModel['From'] = this.requiredFieldErrorMessage;
        } else if (+this.addOrEditEmployeeLogModel.from < 0 || +this.addOrEditEmployeeLogModel.from > 24) {
          this.errorModel['From'] = this.invalidInputMessage;
        }
        
        if(this.addOrEditEmployeeLogModel.to < this.addOrEditEmployeeLogModel.from){
          this.errorModel['From'] = this.invalidInputMessage;
          this.errorModel['To'] = this.invalidInputMessage;
        }

        addModel.to = this.addOrEditEmployeeLogModel.to?.toString();
        addModel.from = this.addOrEditEmployeeLogModel.from?.toString();
      }

      addModel.employeeLogTypeId = this.logType;
      addModel.venueEmployeeId = this.userId;
      addModel.dateTime = moment(this.date).format('MM/DD/YYYY');
      addModel.venueId = this.addOrEditEmployeeLogModel.venueId;

      if (!this.errorModel['From'] && !this.errorModel['To']) {
        this.spinner = true;
        this.disableBtn = true;
        this.employeeService.addEmployeeLog(addModel)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      }
    }
  }

  updateEmployeeLog() {
    this.errorModel = {};
    let addModel = new AddOrEditEmployeeLogModel();

    if (this.logType !== null) {
      if (this.logType === EmployeeLogTypes.Shift) {

        if (this.addOrEditEmployeeLogModel.to === undefined || this.addOrEditEmployeeLogModel.to === null) {
          this.errorModel['To'] = this.requiredFieldErrorMessage;
        } else if (+this.addOrEditEmployeeLogModel.to < 0 || +this.addOrEditEmployeeLogModel.to > 24) {
          this.errorModel['To'] = this.invalidInputMessage;
        }

        if (this.addOrEditEmployeeLogModel.from === undefined || this.addOrEditEmployeeLogModel.from === null) {
          this.errorModel['From'] = this.requiredFieldErrorMessage;
        } else if (+this.addOrEditEmployeeLogModel.from < 0 || +this.addOrEditEmployeeLogModel.from > 24) {
          this.errorModel['From'] = this.invalidInputMessage;
        }
        
        if(this.addOrEditEmployeeLogModel.to < this.addOrEditEmployeeLogModel.from){
          this.errorModel['From'] = this.invalidInputMessage;
          this.errorModel['To'] = this.invalidInputMessage;
        }

        addModel.to = this.addOrEditEmployeeLogModel.to?.toString();
        addModel.from = this.addOrEditEmployeeLogModel.from?.toString();
      }

      addModel.id = this.addOrEditEmployeeLogModel.id;
      addModel.employeeLogTypeId = this.logType;

      if (!this.errorModel['From'] && !this.errorModel['To']) {
        this.spinner = true;
        this.disableBtn = true;

        this.employeeService.updateEmployeeLog(addModel)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: _ => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: _ => {
              this.spinner = false;
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          });
      }
    } else {
      this.removeCurrentEmployeeLog();
    }
  }

  chooseShiftDayType(type: EmployeeLogTypes) {
    if (this.logType === type) {
      this.logType = null;
    } else {
      this.logType = type;
    }
  }

  isShiftDayTypeSelected(type: EmployeeLogTypes) {
    return this.logType === type;
  }

  removeCurrentEmployeeLog(): void {
    this.employeeService.removeEmployeeLog(this.addOrEditEmployeeLogModel.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: _ => {
          this.spinner = false;
          this.ref.close(true)
        },
        error: _ => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }
  //#endregion
}
